
var focusHelper = require("../components/focus");
var urlUtils = require("../search/urlUtils");
var cartUtil = require("../components/cartUtil");
const globalUtil = require("../utilities/globalUtilities");
import { pdpImages } from "../utilities/carouselSlickConfig";
import { reinitInputAnimationEvent } from "../components/formElementsUtil";
import { updateNutritionalTab } from "../product/detailsTabs";
import { initMTabsPDP, triggerSelectionOfOnlyColor } from "../product/detailsUtil";
import { DEFAULT_PAGE_SIZE } from "../utilities/constants";
import { PRICETYPES } from "../utilities/constants";
const $cache = {
    document: $(document),
    body: $("body"),
    transparentImgURL: $(".js-transparent-image-url").data("url"),
    noImageLargeURL: $(".js-no-image-product-url").data("url"),
    isMobile: window.mqRespond.status.mobile
};

/**
 * @function
 * @description - Add/remove class for out of stock if the product is out of stock/in stock
 * @param {Object} data - data object that is coming from ajax request
 */
const updatePDPPageOutOfStockState = data => {
    const $pdpContainer = $(".product-detail");

    if (typeof data != "undefined") {
        const isProductInStock = data?.product?.hasVariationsInStock || !!(data?.isProductInStock);
        $pdpContainer.toggleClass("product-out-of-stock", !isProductInStock).attr("data-is-product-out-of-stock", !isProductInStock);
    } else {
        const isProductWithoutVariants = $(".ct-pdp--variation-wrapper").length == 0;
        const isProductOutOfStock = isProductWithoutVariants ? $(".js-add-to-cart-button").attr("data-outofstock") == "true" : !pdpHasVariantsInStock();
        $pdpContainer.toggleClass("product-out-of-stock", isProductOutOfStock).attr("data-is-product-out-of-stock", isProductOutOfStock);
    }
};

/**
 * @function
 * @description - Add/remove class for out of stock if the product is out of stock/in stock Checks if for the current PDP opened the available variants are in stock or not
 * @return {Boolean} - returns true/false if there are products in stock or not
 */
const pdpHasVariantsInStock = () => {
    const $quickviewContainer = $(".js-product-quickview");
    const isQuickViewOpened = $quickviewContainer && $quickviewContainer.length > 0 && $quickviewContainer.is(":visible");
    const $productDetailContainer = isQuickViewOpened ? $quickviewContainer : $(".product-detail");
    const availableVariants = getAvailableVariations();

    if ($productDetailContainer && $productDetailContainer.length && availableVariants.length) {
        return availableVariants.some(elem => !elem.isOutOfStock);
    }

    return true;
};

/**
 * Process product availability options. It checks and hides the product options that are out of stock
 * @param {Object} $this - Reference to the current element
 * @param {String} type - type to condition the logic to be executed size/color
 */
function processProductionAvailabilityOptions($this, type) {
    const availablevariations = $this.closest(".ct-pdp--variations-wrapper").data("availablevariations");
    const isSizeDisplayed = $(".ct-pdp--variation-wrapper[data-attr='size']").length;
    const isColorDisplayed = $(".ct-pdp--variation-wrapper[data-attr='color']").length;
    let availablevariation;

    if (availablevariations && availablevariations.length && isColorDisplayed && isSizeDisplayed) {
        if (type == "size") {
            const selectedColor = $this.attr("data-id");

            // hide all sizes first
            const $sz = $("select[class*=\"select-size\"]");
            $sz.find("option").each(function (indx, el) {
                if (indx == 0) {
                    return;
                }

                $(el).addClass("d-none");
            });

            // loop by availablevariations for selected color and display available sizes back
            for (let indx in availablevariations) {
                availablevariation = availablevariations[indx];

                if (availablevariation.color === selectedColor) {
                    $sz.find(`[data-attr-value="${availablevariation.size}"]`).removeClass("d-none");
                }
            }
        } else {
            if ($this.hasClass("select-size") && availablevariations.length && type == "color") {
                const $selectedOption = $this.find(`option[value="${$this.val()}"]`);
                const selectedSizeId = $selectedOption.attr("data-attr-value");
                const $clr = $("[data-attr=\"color\"]");

                if (typeof selectedSizeId != "undefined") {
                    // hide all colors first
                    $clr.find("button").each(function (i, el) {
                        $(el).addClass("d-none");
                    });

                    // loop by availablevariations for selected color and open them back
                    for (let indx in availablevariations) {
                        availablevariation = availablevariations[indx];

                        if (availablevariation.size === selectedSizeId) {
                            $clr.find(`[data-id="${availablevariation.color}"]`).removeClass("d-none");
                        }
                    }
                } else {
                    $clr.find("button").each(function (i, el) {
                        $(el).removeClass("d-none");
                    });
                }
            }
        }
    }
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find("[data-attr=\"" + attr.id + "\"] [data-attr-value=\"" +
            attrValue.value + "\"]");
        var $swatchButton = $attrValue.closest("button");

        if (attrValue.selected) {
            $attrValue.addClass("selected");
            $attrValue.siblings(".selected-assistive-text").text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass("selected");
            $attrValue.siblings(".selected-assistive-text").empty();
        }

        if (attrValue.url) {
            $swatchButton.attr("data-url", attrValue.url);
        } else {
            $swatchButton.removeAttr("data-url");
        }

        // Disable if not selectable
        $attrValue.removeClass("selectable unselectable");

        $attrValue.addClass(attrValue.selectable ? "selectable" : "unselectable");
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = "[data-attr=\"" + attr.id + "\"]";
    var availabilityObj = getAvailableVariations();
    var sizeValues = attr.values;
    var selectedSize = sizeValues.filter(obj => {
        return obj.selected == true;
    });

    if (!availabilityObj || !selectedSize.length) {
        $productContainer.find(".pwc-pdp--color-swatches .ct-pdp--color-variation").each(function () {
            $(this).attr("disabled", false);
        });
    }

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + " [data-attr-value=\"" + attrValue.value + "\"]");
        $attrValue.attr("value", attrValue.url)
            .removeAttr("disabled");
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ["color"];
    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });

    //Check the product variation attributes color/size if it has stock. If they don't have stock, the elements are disabled
    initProductOptionsEvents();
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = "";
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = "<li><div>" + response.resources.info_selectforstock + "</div></li>";
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += "<li><div>" + message + "</div></li>";
        });
    }

    $($productContainer).trigger("product:updateAvailability", {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return "";
    }

    var html = "";

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === "mainAttributes") {
            attributeGroup.attributes.forEach(function (attribute) {
                html += "<div class=\"attribute-values\">" + attribute.label + ": "
                    + attribute.value + "</div>";
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find(".product-options").empty().html(optionsHtml);
}

/**
 * Dynamically creates Slick carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, $productContainer, productID) {
    const $imagesContainer = $productContainer.find(".product-images--wrapper");
    let $carousel = $imagesContainer.find(".pdp-images-carousel.slick-initialized");
    let productImages = "";

    if ($carousel.length) { $carousel.slick("destroy"); }
    if (imgs.length == 1) {
        productImages =
        `<div class="pdp-img-container">
            <div class="pdp-carousel-item" data-toggle="modal" data-target="#pdpZoom">
                <img class="ct-product-image"
                    onerror="this.onerror=null;this.src='${$cache.noImageLargeURL}';"
                    src="${imgs[0].url}"
                    alt="${imgs[0].alt}"
                    title="${imgs[0].title}"
                />
            </div>
        </div>`;

        $imagesContainer.find(".pdp-img-container").replaceWith(productImages);
    } else if (imgs.length > 1) {
        imgs.forEach(image => {
            productImages +=
            `<div class="pdp-carousel-item" data-toggle="modal" data-target="#pdpZoom">
                <img class="ct-product-image lazyload hidden"
                    loading="lazy"
                    onerror="this.onerror=null;this.src='${$cache.noImageLargeURL}';"
                    data-src="${image.url}"
                    alt="${image.alt}"
                    title="${image.title}"
                />
            </div>`;
        });

        let carouselContainer =
        `<div id="pdpCarousel-${productID}" class="pdp-images-carousel pdp-img-container hidden-before-init">
            ${productImages}
        </div>`;
        $imagesContainer.find(".pdp-img-container").replaceWith(carouselContainer);

        $carousel = $imagesContainer.find(".pdp-images-carousel");
        $carousel.slick(pdpImages);
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents(".choose-bonus-product-dialog").length > 0;
    var isVaraint;
    var $btnAddtoCart = $(".ct-pdp--add-CTA button.add-to-cart");
    var $btnAddtoFavorites = $productContainer.find(".product-name-details--wrapper .wishlist-toggler");
    var addToFavoritesUrl = $btnAddtoFavorites.data("add-url");
    var regPid = new RegExp(".*pid=([0-9]+)");
    if (regPid.test(addToFavoritesUrl)) {
        var oldPid = addToFavoritesUrl.match(regPid);
        addToFavoritesUrl = addToFavoritesUrl.replace(oldPid[1], response.product.id);
    }
    var removeToFavoritesUrl = $btnAddtoFavorites.data("remove-url");
    if (regPid.test(removeToFavoritesUrl)) {
        var oldPidUrl = removeToFavoritesUrl.match(regPid);
        removeToFavoritesUrl = removeToFavoritesUrl.replace(oldPidUrl[1], response.product.id);
    }
    $btnAddtoFavorites.attr("data-pid", response.product.id);
    $btnAddtoFavorites.attr("data-add-url", addToFavoritesUrl);
    $btnAddtoFavorites.attr("data-remove-url", removeToFavoritesUrl);

    var customActiveClass = $btnAddtoFavorites.data("custom-active-class");
    var customInactiveClass = $btnAddtoFavorites.data("custom-inactive-class");

    if (response.productExistsInWishList) {
        $btnAddtoFavorites
            .removeClass("inactive")
            .removeClass(customInactiveClass)
            .addClass("active")
            .addClass(customActiveClass);
    } else {
        $btnAddtoFavorites
            .removeClass("active")
            .removeClass(customActiveClass)
            .addClass("inactive")
            .addClass(customInactiveClass);
    }

    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === "variant";
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent(".bonus-product-item")
                .data("pid", response.product.id);

            $productContainer.parent(".bonus-product-item")
                .data("ready-to-order", response.product.readyToOrder);
        }
    }

    //update add to cart button text and active/inactive state
    $productContainer.find(".ct-pdp--add-CTA .add-to-cart").html(response.product.addToCartButtonText);
    //add class to product container
    if (response.product.available) {
        $productContainer.removeClass("product-out-of-stock");
        $btnAddtoCart.removeClass("button--primary-inactive").addClass("button--primary");
    } else {
        $productContainer.addClass("product-out-of-stock");
        $btnAddtoCart.addClass("button--primary-inactive").removeClass("button--primary");
    }

    // Update primary images
    var primaryImageUrls = response.product.pdpImages;
    const productID = response.product.id;
    createCarousel(primaryImageUrls, $productContainer, productID);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $(".prices .price", $productContainer).length
            ? $(".prices .price", $productContainer)
            : $(".prices .price");
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find(".promotions").empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find(".select-bonus-product");
        $selectButton.trigger("bonusproduct:updateSelectButton", {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $(".ct-pdp--add-CTA button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global").trigger("product:updateAddToCart", {
            product: response.product, $productContainer: $productContainer
        }).trigger("product:statusUpdate", response.product);
    }

    // Update attributes
    $productContainer.find(".main-attributes").empty()
        .html(getAttributesHtml(response.product.attributes));

    // Update badges
    updateBadge($productContainer, response.product.badgeInfo, "promo", response.product.productBrandID);
    updateBadge($productContainer, response.product.badgeInfo, "general", response.product.productBrandID);

    // Update the short description
    updateShortDescription(response.product.shortDescription);

    // Update product name
    updateProductName(response.product.productName);

    // Update product brand and brand link
    updateBrand(response.product.brand, response.product.brandRefineURL);

    // Update confirmation popup image
    updateProductConfirmationImage($productContainer, response.product.confirmationImage);


    //Updates the notes area
    updateNotes($productContainer, response.product.notes);

    //Updates the quantity input area for selected variation on PDP.
    updateQuantityVariation($productContainer, response.product.quantity);

    //Updates the tabs area
    updateTabs($productContainer, response.product.productTabs, response.product.nutritionalInfoUrlString);

    //Update measure note
    $productContainer.find(".ct-pdp--unit").html(response.product.measurementNote);

    // Update additional information - promo time and delivery time
    updateAdditionalInfo(response.product);
}

/**
 * Updates the badges information
 * @param {jQuery} $container - DOM element for a given product.
 * @param {object} badgeInfo - the badges info
 * @param {string} badgeType - the type of the badge
 * @param {string} brandID - the product brand ID
 */
function updateBadge($container, badgeInfo, badgeType, brandID) {
    var $badgeEl = $container.find(`.${badgeType}BadgeImage`);

    if ($badgeEl) {
        // Clean the element
        $badgeEl.empty();

        // Adds badge img tag
        if (badgeType in badgeInfo && badgeInfo[badgeType]) {
            var badge = badgeInfo[badgeType];
            var html = `<img class="img-fluid lazyload hidden" loading="lazy" data-src="${badge.img}" alt="${badge.alt}" title="${badge.title}" />`;
            if (badge.showDiscountValue) {
                html += `
                        <div class="ct-product-tile-badge-value-wrapper ${brandID}-product-tile-badge-value-wrapper ct-product-tile-badge-value-wrapper--${badge.type} ${brandID}-product-tile-badge-value-wrapper--${badge.type} ${badge.type == "superprice" && badge.showDiscountMessage ? "ct-product-tile-badge-value-wrapper--with-text " + brandID + "-product-tile-badge-value-wrapper--with-text" : ""} ${badge.floatValue ? "ct-product-tile-badge-value-wrapper--float" : ""}">
                            <div class="ct-product-tile-badge-addition d-none flex-column align-self-center text-center ${badge.showPlusDESignOnBadge ? "d-flex" : ""}">
                                <span class="ct-product-tile-badge-addition--sign">
                                    ${badge.plusLabel || ""}
                                </span>
                                <span class="ct-product-tile-badge-addition--text">
                                    ${badge.thanLabel || ""}
                                </span>
                            </div>
                            <span class="ct-product-tile-badge-value--${badge.type} ${brandID}-product-tile-badge-value--${badge.type}">${badge.discount || ""}</span>
                            <span class="ct-product-tile-badge-value--${badge.type}-quantifier ${brandID}-product-tile-badge-value--${badge.type}-quantifier ${badge.type == "superprice" && badge.showDiscountMessage ? "d-none" : ""}">${badge.unit || ""}</span>
                        </div>`;
            }
            $badgeEl.html(html);
        }
    }
}

/**
 * Updates the notes information
 * @param {jQuery} $container - DOM element for a given product.
 * @param {object} notesObj - notes object containing the HTML
 */
function updateNotes($container, notesObj) {
    if (typeof notesObj == "object" && "html" in notesObj) {
        $container.find(".js-notes-container").html(notesObj.html);
        reinitInputAnimationEvent($container.find(".add-product-note"));
    }
}

/**
 * Updates the quantity input section on PDP after variation selected
 * @param {jQuery} $container - DOM element for a given product.
 * @param {object} quantityObj - quantity object containing the HTML
 */
function updateQuantityVariation($container, quantityObj) {
    if (typeof quantityObj == "object" && "html" in quantityObj) {
        $container.find(".ct-pdp--add-CTA .ct-tile-quantity").empty().replaceWith(quantityObj.html);

        //hide the 'add to cart' button once product is in basket already
        if (!$container.find(".ct-pdp--add-CTA .ct-tile-quantity").hasClass("d-none")) {
            $container.find(".ct-pdp--add-CTA .add-to-cart").addClass("d-none");
        }

        let productQtyMap = cartUtil.getProductQtyMap();
        //update product quantity input
        $cache.body.trigger("product:syncTileData", productQtyMap);
    }
}

/**
 * Updates the product short description
 * @param {String} shortDescription - Product short description
 */
const updateShortDescription = shortDescription => {
    const shortDescriptionEl = document.querySelector(".ct-pdp--short-description");

    if (shortDescriptionEl) {
        shortDescriptionEl.textContent = shortDescription ? shortDescription : "";
    }
};

/**
 * Updates product confirmation popup image
 * @param {Element} $productContainer - Product container
 * @param {Object} confirmationImageObj - Confirmation image object
 */
const updateProductConfirmationImage = ($productContainer, confirmationImageObj) => {
    const productImages = $productContainer.find(".product-images");
    const removeProductTile = $productContainer.find(".tile-delete-confirmation-btn");

    if (productImages && removeProductTile && confirmationImageObj) {
        productImages.data("confirmation-image", confirmationImageObj);
        removeProductTile.data("confirmation-image", confirmationImageObj);
    }
};

/**
 * Updates the details tab section on PDP after variation selected
 * @param {jQuery} $container - DOM element for a given product detail page.
 * @param {object} tabsObj - product tabs object
 * @param {string} nutritionalUrl - nutritional url string
 */
function updateTabs($container, tabsObj, nutritionalUrl) {
    if (!$container.length) { return; }

    const $tabsContainer = $container.find(".description-and-detail");
    const $sizesSelector = $container.get(0).querySelector(".pwc-custom-select");
    const isSizeNotSelected = $sizesSelector && $sizesSelector.options[$sizesSelector.selectedIndex].text == $sizesSelector.options[0].text;

    // return if variant has size variation but is not selected
    if (isSizeNotSelected) {
        $tabsContainer.find(".ct-pdp--description-tabs").remove();
        return;
    }

    let tabListItemsHTML = "";
    let tabsDetailsHTML = "";
    let nutritionalListItemHTML = generateNutritionalTabHTML(nutritionalUrl);
    let tabHasValues = tabsObj.some(tab => {
        return tab.hasValues == true;
    });

    if (typeof tabsObj == "object") {
        tabListItemsHTML = generateProductTabsHTML(tabsObj);
        tabsDetailsHTML = generateTabsAttrValuesHTML(tabsObj);
    }

    let tabsHTML =
    `
    <div class="ct-pdp--description-tabs pwc-border--radius ${tabHasValues ? "" : "hidden"}">
        <div class="row no-gutters js-description-tabs">
            <ul class="col-sm-4 col-md-3 tabNav">
                ${tabListItemsHTML}
                ${nutritionalListItemHTML}
            </ul>
            ${tabsDetailsHTML}
        </div>
    </div>
    `;

    $tabsContainer.find(".ct-pdp--description-tabs").remove();
    $tabsContainer.append(tabsHTML);

    initMTabsPDP();
    updateNutritionalTab();
    globalUtil.loadLazyImages(".ct-pdp--description-tabs");
}

/**
 * Generates the HTML for the list items of product details tabs
 * @param {object} tabsObj - product tabs object
 * @return {string} - returns HTML string
 */
function generateProductTabsHTML(tabsObj) {
    let tabListItemsHTML = "";

    tabsObj.forEach((productTab, tabIndex) => {
        if (!productTab.hasValues) { return tabListItemsHTML; }
        tabListItemsHTML +=
        `
        <li>
            <button
                type="button"
                class="tab-title-overlay js-tab-title-overlay d-block d-sm-none"
                name="${productTab.title}"
            ></button>
            <a href="#collapsible-description-${tabIndex}"
                class="js-details-header"
                data-isloaded="${tabIndex == 0}"
                data-tabindex="${productTab.tabIndex}"
            >
                ${productTab.title}
                <span class="tab-arrow-right">
                    ${globalUtil.getSVGIcon("icon-arrow-right")}
                </span>
                <span class="tab-arrow-closed">
                    ${globalUtil.getSVGIcon("icon-arrow-down")}
                </span>
                <span class="tab-arrow-open">
                    ${globalUtil.getSVGIcon("icon-arrow-up")}
                </span>
            </a>
        </li>
        `;
    });

    return tabListItemsHTML;
}

/**
 * Generates the HTML for the nutritional tab of product details tabs
 * @param {string} nutritionalUrl - nutritional url string
 * @return {string} - returns HTML string
 */
function generateNutritionalTabHTML(nutritionalUrl) {
    const tabTitle = $(".js-nutritional-tab-title").attr("data-title");
    const tableTabTitle = $(".js-nutritional-tab-title").attr("data-title");
    let nutritionalListItemHTML = "";

    if (nutritionalUrl)  {
        nutritionalListItemHTML =
        `
        <li class="nutriTableInfoTab js-nutritional-table-tab-header d-none">
            <button 
                type="button" 
                class="tab-title-overlay js-tab-title-overlay d-block d-sm-none" 
                name="${tableTabTitle}"
            ></button>
            <a href="#collapsible-description-nutritional-table"
                class="js-details-header js-nutritional-table-tab-anchor d-none"
                data-isloaded="${false}" data-tabindex="s4"
            >
                ${tableTabTitle}
                <span class="tab-arrow-right">
                    ${globalUtil.getSVGIcon("icon-arrow-right")}
                </span>
                <span class="tab-arrow-closed">
                    ${globalUtil.getSVGIcon("icon-arrow-down")}
                </span>
                <span class="tab-arrow-open">
                    ${globalUtil.getSVGIcon("icon-arrow-up")}
                </span>
            </a>
        </li>

        <li class="nutriInfoTab js-nutritional-tab-header d-none">
            <button
                type="button"
                class="tab-title-overlay js-tab-title-overlay d-block d-sm-none"
                name="${tabTitle}"
            ></button>
            <a href="#collapsible-description-nutritional"
                class="js-details-header js-nutritional-tab-anchor d-none"
                data-url="${nutritionalUrl}"
                data-isloaded="${false}" data-tabindex="s5"
            >
                ${tabTitle}
                <span class="tab-arrow-right">
                    ${globalUtil.getSVGIcon("icon-arrow-right")}
                </span>
                <span class="tab-arrow-closed">
                    ${globalUtil.getSVGIcon("icon-arrow-down")}
                </span>
                <span class="tab-arrow-open">
                    ${globalUtil.getSVGIcon("icon-arrow-up")}
                </span>
            </a>
        </li>
        `;
    }

    return nutritionalListItemHTML;
}

/**
 * Generates the HTML for the tab attributes values of product details tabs
 * @param {object} tabsObj - product tabs object
 * @return {string} - returns HTML string
 */
function generateTabsAttrValuesHTML(tabsObj) {
    let tabAttrValues = "";

    tabsObj.forEach((productTab, tabIndex) => {
        if (!productTab.attributesValues || !productTab.hasValues) { return tabAttrValues; }

        tabAttrValues +=
        `
        <div class="tabContent" id="collapsible-description-${tabIndex}" data-tabindex=${productTab.tabIndex}>
            <div class="ct-pdp--description-content" data-simplebar>
        `;

        productTab.attributesValues.forEach(attribute => {
            if (attribute.attributeType === "string" || attribute.attributeType === "text") {
                tabAttrValues +=
                `
                <p class="mb-0">
                    ${attribute.attributeIdTranslated}:
                </p>
                <p class="mb-20">
                    ${attribute.attributeValue}
                </p>
                `;
            } else if (attribute.attributeType === "image") {
                tabAttrValues +=
                `
                <p class="mb-0 ${attribute.attributeIsMultiBreakpoints ? attribute.attributeIsMobile ? "d-block d-md-none" : "d-none d-md-block" : ""}">
                    ${attribute.attributeIdTranslated}:
                </p>
                <img class="ct-pdp--description-image img-fluid lazyload hidden ${attribute.attributeIsMultiBreakpoints ? attribute.attributeIsMobile ? "d-block d-md-none" : "d-none d-md-block" : ""}"
                    loading="lazy"
                    data-src="${attribute.attributeValue}"
                    alt="${attribute.attributeIdTranslated}"
                    title="${attribute.attributeIdTranslated}" />
                `;
            }
        });

        tabAttrValues +=
        `
            </div>
        </div>
        `;
    });

    const tabsDetailsHTML =
    `
    <div class="col-sm-8 col-md-9 tabContainer tab-row-details">
        ${tabAttrValues}

        <div class="tabContent js-nutri-table-tab-wrapper d-none" id="collapsible-description-nutritional-table" data-tabindex="s4"></div>
        <div class="tabContent js-nutri-tab-wrapper d-none" id="collapsible-description-nutritional" data-tabindex="s5"></div>
    </div>
    `;

    return tabsDetailsHTML;
}

/**
 * Updates the product name
 * @param {String} productName - Product name
 */
const updateProductName = productName => {
    const productNameEl = document.querySelector(".product-name");

    if (productNameEl && productName) {
        productNameEl.textContent = productName;
    }
};

/**
 * Updates the product additional information section
 * @param {object} product - `product` object from the response, that contains the information needed
 */
const updateAdditionalInfo = product => {
    const additionalInfoWrapper = document.querySelector(".ct-pdp--additional-info-wrapper");

    if (!additionalInfoWrapper) { return; }

    const isPromoTimeResponse = product.badgeInfo?.promo != undefined && product.badgeInfo?.promo?.promoTime !== "" && product.badgeInfo?.promo?.type != PRICETYPES.PVPR;
    const promoTimeHTML = isPromoTimeResponse ? `
        <div class="product-promo-time--wrapper ct-pdp--promo-time-wrapper pwc-mt--10">
            <div class="ct-pdp--promo-time">
                ${isPromoTimeResponse ? globalUtil.getSVGIcon("icon-calendar") : ""}
                <span class="ct-pdp--promo-time-text">
                    ${isPromoTimeResponse ? product.badgeInfo.promo.promoTime : ""}
                </span>
            </div>
        </div>
    ` : "";

    const isDeliveryTime = product?.deliveryTime != undefined;
    const deliveryTimeHTML = isDeliveryTime ? `
        <div class="product-delivery--wrapper ct-pdp--delivery-wrapper pwc-mt--10">
            <div class="ct-pdp--delivery-time">
                ${product.deliveryTime}
            </div>
        </div>
    ` : "";

    const additionalInfoHTML = `
        <div class="ct-pdp--additional-info">
            ${promoTimeHTML}
            ${deliveryTimeHTML}
        </div>
    `;

    additionalInfoWrapper.innerHTML = isPromoTimeResponse || isDeliveryTime ? additionalInfoHTML : "";
};

/**
 * Updates the product brand and brand link
 * @param {String} productBrand - Product brand
 * @param {String} brandRefineURL - Product brand link
 */
const updateBrand = (productBrand, brandRefineURL) => {
    const productBrandEl = document.querySelector(".ct-pdp--brand");

    if (productBrandEl && productBrand) {
        productBrandEl.textContent = productBrand;
    }

    if (productBrandEl && brandRefineURL) {
        productBrandEl.href = brandRefineURL;
    }
};

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if (!($productContainer.parent(".bonus-product-item").length > 0)) { //NOSONAR
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? " selected " : "";
            return "<option value=\"" + quantity.value + "\"  data-url=\"" + quantity.url + "\"" +
                selected + ">" + quantity.value + "</option>";
        }).join("");
        cartUtil.getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    //1. hide quantity input
    var $qtyField = $productContainer.find(".ct-tile-quantity"); // better to find this $(".ct-tile-quantity." + productID);
    $qtyField.addClass("d-none");

    //2. show back add to cart
    var $btnAddtoCart = $productContainer.find("button.add-to-cart:not(.js-add-to-cart-tile)");
    $btnAddtoCart.removeClass("d-none");
    $btnAddtoCart.removeClass("hide");

    if (selectedValueUrl) {
        $("body").trigger("product:beforeAttributeSelect",
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: "GET",
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                updateProductAvailableVariantsAttribute(data);
                initProductOptionsEvents();
                initAddToCartButtonState(data, $btnAddtoCart);
                updatePDPPageOutOfStockState(data);
                globalUtil.loadLazyImages(".product-images-container");

                $("body").trigger("product:afterAttributeSelect",
                    { data: data, container: $productContainer });

                var $variationError = $productContainer.find(".ct-pdp--variation-error");

                if (cartUtil.checkProductVariations($(".add-to-cart"))) {
                    $variationError.addClass("d-none");
                }

                document.dispatchEvent(new CustomEvent("dataLayer.variantChange", {
                    detail: {
                        "dataLayerObject": data?.dataLayerObject
                    }
                }));
            },
            complete: function (data) {
                if (data.responseJSON && data.responseJSON.product) {
                    globalUtil.initializeQtyComponent(data.responseJSON.product.id);
                }
                if (window.mqRespond.status.mobile) { cartUtil.handlePDPAddToCartModal(); }

                $.spinner().stop();
            }
        });
    }
}

/**
 * Get product available variations from data attribute
 * @return {Array} - get product available variations
 */
function getAvailableVariations() {
    const $quickviewContainer = $(".js-product-quickview");
    const isQuickViewOpened = $quickviewContainer && $quickviewContainer.length > 0 && $quickviewContainer.is(":visible");
    const $pdpContainer = isQuickViewOpened ? $quickviewContainer : $(".product-detail");
    var availabilityVariations = $pdpContainer.find(".js-add-to-cart-button, .ct-pdp--variations-wrapper").attr("data-availablevariations");
    var availabilityObj = null;
    var variations = [];

    try {
        availabilityObj = JSON.parse(availabilityVariations);
    } catch (e) {
        availabilityObj = null;
    }

    if (availabilityObj) {
        var keys = Object.keys(availabilityObj);

        for (var i = 0; i < keys.length; i++) {
            variations.push(availabilityObj[keys[i]]);
        }
    }

    return variations;
}

/**
 * Check if an element should be disabled or not
 * @param {Object} $el - the element to be checked if should be disabled or not
 * @param {Array} list - the list based on which is determined if the element is disabled or not
 * @param {String} attr - the attribute that is used for comparison
 * @param {Object} config - contains information about the current size/color selected
 */
function checkIfElementShouldBeDisabled($el, list, attr, config) {
    if (!$el || !list || !attr) {
        return;
    }

    var val = $el.attr("data-attr-value");

    if (val) {
        var el = [];

        if (config) {
            el = list.filter(function (obj) {
                return obj[attr] == val && !obj.isOutOfStock && obj[config.attrID] == config.attrValue;
            });
        } else {
            el = list.filter(function (obj) {
                return obj[attr] == val && !obj.isOutOfStock;
            });
        }

        if (el.length == 0) {
            if (attr == "color") {
                $el.addClass("js-no-selected-size-stock");
            } else {
                $el.attr("disabled", true);
                $el.attr("selected", false);
            }
        } else {
            if (attr == "color") {
                $el.removeClass("js-no-selected-size-stock");
            } else {
                $el.attr("disabled", false);
            }
        }
    }
}

/**
 * Updates product available variants data attribute on PDP
 * @param {Object} data
 */
const updateProductAvailableVariantsAttribute = data => {
    const $pdpVariantsWrapper = $(".ct-pdp--variations-wrapper");

    if (data?.product?.availableVariations && $pdpVariantsWrapper?.length) {
        $pdpVariantsWrapper.attr("data-availablevariations", JSON.stringify(data.product.availableVariations));
    } else {
        const availableVariants = $(".js-add-to-cart-button").data("availablevariations");

        if (!globalUtil.hasNotAllowedValues(availableVariants) && $pdpVariantsWrapper?.length) {
            $pdpVariantsWrapper.attr("data-availablevariations", JSON.stringify(availableVariants));
        }
    }
};

/**
 * On page ready check if the variations have stock or not. If they don't have stock, the related select is disabled
 */
function initProductOptionsEvents() {
    const $quickviewContainer = $(".js-product-quickview");
    const isQuickViewOpened = $quickviewContainer && $quickviewContainer.length > 0 && $quickviewContainer.is(":visible");
    const $container = isQuickViewOpened ? $quickviewContainer : $(".product-detail");
    const variations = getAvailableVariations();

    if (variations && variations.length) {
        const $sizeOptions = $container.find("select.select-size option");
        const $colorOptions = $container.find(".pwc-pdp--color-swatches button, .pwc-pdp--color-swatches a.quickview");
        let obj = null;

        if ($sizeOptions.length) {
            const $selectedColorElem = $container.find(".ct-pdp--color-variation.selected");
            const selectedColorValue = $selectedColorElem.length ? $selectedColorElem.attr("data-attr-value") : "";
            obj = selectedColorValue != "" && selectedColorValue != undefined ? {attrID: "color", attrValue: selectedColorValue} : null;

            $sizeOptions.each(function () {
                checkIfElementShouldBeDisabled($(this), variations, "size", obj);
            });
            let hasColorAttribute = $colorOptions.length ? true : false;
            hideOufOfRangeSizes(hasColorAttribute, selectedColorValue, variations);
        }

        if ($colorOptions.length) {
            const $selectedSizeElem = $container.find(".select-size option:selected");
            const selectedSizeValue = $selectedSizeElem.length ? $selectedSizeElem.attr("data-attr-value") : "";
            obj = selectedSizeValue != "" && selectedSizeValue != undefined ? {attrID: "size", attrValue: selectedSizeValue} : null;

            $colorOptions.each(function () {
                checkIfElementShouldBeDisabled($(this), variations, "color", obj);
            });
        }
    }
}

/**
 * Hides all sizes that are out of range for the selected color
 * @param {String} selectedColorValue - the selected color value
 * @param {Array} variations - all the products varaiations
 */

const hideOufOfRangeSizes = (hasColorAttribute, selectedColorValue, variations) => {
    let outOfRangeSizes = [];

    variations.map(function (obj) {
        if (hasColorAttribute && obj["color"] == selectedColorValue && obj.isOutOfRange) {
            outOfRangeSizes.push(obj.size);
        }
        if (!hasColorAttribute && obj.isOutOfRange) {
            outOfRangeSizes.push(obj.size);
        }
    });

    $(".pwc-custom-select.select-size>option").map(function () {
        let attrValueId =  $(this).data("variation-id");

        $(this).removeClass("d-none");

        if (outOfRangeSizes.indexOf(attrValueId) != -1) {
            $(this).addClass("d-none");
        }
    });
};

/**
 * Init the state for the add to cart button on PDP
 * @param {Object} data - data object coming from ajax request
 * @param {Object} $this - current DOM object
 */

const initAddToCartButtonState = (data, $this) => {
    const $addToCartButton = $this;
    let hasVariationsInStock = data?.product?.hasVariationsInStock || !!data?.isProductInStock;
    const addToCartButtonText = data?.product?.addToCartButtonText ? data.product.addToCartButtonText : ("addToCartButtonText" in data ? data.addToCartButtonText : "");
    const addToCartButtonTextDisabled = data?.product?.addToCartButtonTextNotAvailable ? data.product.addToCartButtonTextNotAvailable : ("addToCartButtonTextNotAvailable" in data ? data.addToCartButtonTextNotAvailable : "");
    const $colorSwatchesLength = $(".ct-pdp--color-variation").length;
    const $colorSwatchesDisabled = $(".ct-pdp--color-variation:disabled").length;
    const $addToCartButtonTextContainer = $addToCartButton.find(".add-to-cart--text");

    if ($colorSwatchesLength && $colorSwatchesDisabled == $colorSwatchesLength) {
        $addToCartButtonTextContainer.length > 0 ? $addToCartButtonTextContainer.text(addToCartButtonTextDisabled) : $addToCartButton.text(addToCartButtonTextDisabled);
        hasVariationsInStock = false;
    } else if (addToCartButtonText && !$cache.isMobile) {
        $addToCartButtonTextContainer.length > 0 ? $addToCartButtonTextContainer.text(addToCartButtonText) : $addToCartButton.text(addToCartButtonText);
    }

    $addToCartButton.attr("data-pid", data.product.id);
    $addToCartButton.attr("data-outofstock", !hasVariationsInStock);
    $addToCartButton.prop("disabled", !hasVariationsInStock);
};

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            cartUtil.chooseBonusProducts(data);
        }
    },
    focusChooseBonusProductModal: function () {
        $("body").on("shown.bs.modal", "#chooseBonusProductModal", function () {
            $("#chooseBonusProductModal").siblings().attr("aria-hidden", "true");
            $("#chooseBonusProductModal .close").focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $("body").on("hidden.bs.modal", "#chooseBonusProductModal", function () {
            $("#chooseBonusProductModal").siblings().attr("aria-hidden", "false");
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $("body").on("keydown", "#chooseBonusProductModal", function (e) {
            var focusParams = {
                event: e,
                containerSelector: "#chooseBonusProductModal",
                firstElementSelector: ".close",
                lastElementSelector: ".add-bonus-products"
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $cache.document.on("click", "[data-attr=\"color\"] button", function (e) {
            e.preventDefault();

            const isQuickViewOpened = $(".js-product-quickview").length > 0 && $(".js-product-quickview").is(":visible");
            const $this = $(e.currentTarget);
            const sizeSelector = document.querySelector(".select-size");

            if (isQuickViewOpened || $(this).attr("disabled")) { return; }

            if ($this.hasClass("js-no-selected-size-stock") && sizeSelector) {
                $this.removeClass("js-no-selected-size-stock");
                sizeSelector.selectedIndex = 0;
            }

            let $productContainer = $(this).closest(".set-item");

            if (!$productContainer.length) {
                $productContainer = $(this).closest(".product-detail");
            }

            processProductionAvailabilityOptions($(this), "size");
            attributeSelect($(this).attr("data-url"), $productContainer);
        });
    },

    selectAttribute: function () {
        $cache.document.on("change", "select[class*=\"select-\"], .options-select", function (e) {
            e.preventDefault();
            const isQuickViewOpened = $(".js-product-quickview").length > 0 && $(".js-product-quickview").is(":visible");

            if (isQuickViewOpened) { return; }

            var $productContainer = $(this).closest(".set-item");

            if (!$productContainer.length) {
                $productContainer = $(this).closest(".product-detail");
            }

            processProductionAvailabilityOptions($(this), "color");
            attributeSelect(e.currentTarget.value, $productContainer);
        });
    },

    /**
     * Updates product availability options
     */
    updateProductAvailabilityOptions: function () {
        updateProductAvailableVariantsAttribute();
        initProductOptionsEvents();
        updatePDPPageOutOfStockState();
        triggerSelectionOfOnlyColor();
    },

    /**
     * Product availability
     */
    availability: function () {
        $cache.document.on("change", ".quantity-select", function (e) {
            e.preventDefault();

            let $productContainer = $(this).closest(".product-detail");

            if (!$productContainer.length) {
                $productContainer = $(this).closest(".modal-content").find(".product-quickview");
            }

            if ($(".bundle-items", $productContainer).length === 0) {
                attributeSelect($(e.currentTarget).find("option:selected").data("url"),
                    $productContainer);
            }
        });
    },
    selectBonusProduct: function () {
        $cache.document.on("click", ".select-bonus-product", function () {
            var $choiceOfBonusProduct = $(this).parents(".choice-of-bonus-product");
            var pid = $(this).data("pid");
            var maxPids = $(".choose-bonus-product-dialog").data("total-qty");
            var submittedQty = parseInt($choiceOfBonusProduct.find(".bonus-quantity-select").val(), 10);
            var totalQty = 0;
            $.each($("#chooseBonusProductModal .selected-bonus-products .selected-pid"), function () {
                totalQty += $(this).data("qty");
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find(".product-option").data("option-id");
            var valueId = $choiceOfBonusProduct.find(".options-select option:selected").data("valueId");
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ""
                + "<div class=\"selected-pid row\" "
                + "data-pid=\"" + pid + "\""
                + "data-qty=\"" + submittedQty + "\""
                + "data-optionID=\"" + (optionID || "") + "\""
                + "data-option-selected-value=\"" + (valueId || "") + "\""
                + ">"
                + "<div class=\"col-sm-11 col-9 bonus-product-name\" >"
                + $choiceOfBonusProduct.find(".product-name").html()
                + "</div>"
                + "<div class=\"col-1\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></div>"
                + "</div>"
                ;
                $("#chooseBonusProductModal .selected-bonus-products").append(selectedBonusProductHtml);
                $(".pre-cart-products").html(totalQty);
                $(".selected-bonus-products .bonus-summary").removeClass("alert-danger");
            } else {
                $(".selected-bonus-products .bonus-summary").addClass("alert-danger");
            }
        });
    },
    removeBonusProduct: function () {
        $cache.document.on("click", ".selected-pid", function () {
            $(this).remove();
            var $selected = $("#chooseBonusProductModal .selected-bonus-products .selected-pid");
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data("qty"), 10);
                });
            }

            $(".pre-cart-products").html(count);
            $(".selected-bonus-products .bonus-summary").removeClass("alert-danger");
        });
    },
    enableBonusProductSelection: function () {
        $("body").on("bonusproduct:updateSelectButton", function (e, response) {
            $("button.select-bonus-product", response.$productContainer).attr("disabled",
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $("button.select-bonus-product", response.$productContainer).data("pid", pid);
        });
    },
    showMoreBonusProducts: function () {
        $cache.document.on("click", ".show-more-bonus-products", function () {
            var url = $(this).data("url");
            $(".modal-content").spinner().start();
            $.ajax({
                url: url,
                method: "GET",
                success: function (html) {
                    var parsedHtml = cartUtil.parseHtml(html);
                    $(".modal-body").append(parsedHtml.body);
                    $(".show-more-bonus-products:first").remove();
                    $(".modal-content").spinner().stop();
                },
                error: function () {
                    $(".modal-content").spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $cache.document.on("click", ".add-bonus-products", function () {
            var $readyToOrderBonusProducts = $(".choose-bonus-product-dialog .selected-pid");
            var queryString = "?pids=";
            var url = $(".choose-bonus-product-dialog").data("addtocarturl");
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption =
                    parseInt($(this)
                        .data("qty"), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data("optionid") && $(this).data("option-selected-value")) {
                        option = {};
                        option.optionId = $(this).data("optionid");
                        option.productId = $(this).data("pid");
                        option.selectedValueId = $(this).data("option-selected-value");
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data("pid"),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($(".pre-cart-products").html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + "&uuid=" + $(".choose-bonus-product-dialog").data("uuid");
            queryString = queryString + "&pliuuid=" + $(".choose-bonus-product-dialog").data("pliuuid");
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: "POST",
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $("#chooseBonusProductModal").modal("hide");
                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class=\"add-to-cart-messages\"></div>");
                        }
                        $(".add-to-cart-messages").append(
                            "<div class=\"alert alert-danger add-to-basket-alert text-center\""
                            + " role=\"alert\">"
                            + data.errorMessage + "</div>"
                        );

                        //GTM logic - Start
                        document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                            detail: {
                                "success": false,
                                "messageContent": data.errorMessage
                            }
                        }));
                        //GTM logic - End

                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                        }, 3000);
                    } else {
                        $(".configure-bonus-product-attributes").html(data);
                        $(".bonus-products-step2").removeClass("hidden-xl-down");
                        $("#chooseBonusProductModal").modal("hide");

                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class=\"add-to-cart-messages\"></div>");
                        }
                        $(".minicart-quantity").html(data.totalQty);
                        $(".add-to-cart-messages").append(
                            "<div class=\"alert alert-success add-to-basket-alert text-center\""
                            + " role=\"alert\">"
                            + data.msgSuccess + "</div>"
                        );

                        //GTM logic - Start
                        document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                            detail: {
                                "success": true,
                                "messageContent": data.msgSuccess
                            }
                        }));
                        //GTM logic - End
                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                            if ($(".cart-page").length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    saveTileToLocalStorage: () => {
        $cache.document.on("click", ".pwc-tile--description, .ct-image-container, .pwc-image-product-set-url", e => {
            e.preventDefault();

            let href;
            let newURL;
            const $this = $(e.currentTarget);
            if ($this.closest(".ct-product-tile--entrega-zero-product").length) { return; }

            if ($this.hasClass("pwc-tile--description")) {
                href = $this.is("a") ? $this[0].href : $this.parent()[0].href;
            } else if ($this.hasClass("ct-image-container")) {
                href = $this.find("a")[0].href;
            } else if ($this.hasClass("pwc-image-product-set-url")) {
                href = $this[0].href;
            }

            const $tile = $this.closest(".product");

            var url = $(".permalink").val();
            if (url && !$this.hasClass("pwc-carousel")) {
                var numberOfProducts = urlUtils.getURLParameter(url, "sz");
                var pageNumber = 1;

                if (numberOfProducts !== 0 && numberOfProducts !== null) {
                    pageNumber = numberOfProducts / DEFAULT_PAGE_SIZE;
                }

                var clickedProductObject = {clickedProduct: $tile.attr("data-pid"), page: pageNumber, url: window.location.origin + window.location.pathname};

                localStorage.setItem("clickedProduct", JSON.stringify(clickedProductObject));
            }

            //get real chunk start number for product tile
            const start = Number($this.closest(".productTile").prevAll("[class^='page-placeholder']:first").data("start"));

            if (!start || start === 0 || isNaN(start)) {
                const startExists = urlUtils.getURLParameter(location.href, "start");
                if (startExists) {
                    //here must be without "start" in URL
                    newURL = urlUtils.removeFromUrl(location.href, "start");
                    history.pushState({}, "", newURL);
                }
            } else {
                newURL = urlUtils.updateQueryParameter(location.href, "start", start);
                history.pushState({}, "", newURL);
            }

            if (!$this.hasClass("checkout-alternative-products")) {
                window.location = href;
            }
        });
    },

    getPidValue: cartUtil.getPidValue,
    getQuantitySelected: cartUtil.getQuantitySelected,
    miniCartReportingUrl: cartUtil.miniCartReportingUrl,
    initProductOptionsEvents: initProductOptionsEvents,
    updatePDPPageOutOfStockState: updatePDPPageOutOfStockState,
    initAddToCartButtonState: initAddToCartButtonState
};
